
export const METHOD_LIST = 'support-question/';
export const METHOD_LIST_SUPPORT = 'support/';

export const MSG_WARNING_DELETE_QUESTION = 'Are you sure to delete this question?'
export const MSG_DELETE_QUESTION_SUCCESS = 'Support question deleted successfully';